import {
  CREATE_ATTENDANCE_FAILED,
  CREATE_ATTENDANCE_REQ,
  CREATE_ATTENDANCE_SUCCESS,
  GET_ATTENDANCE_FAILED,
  GET_ATTENDANCE_REQ,
  GET_ATTENDANCE_SUCCESS,
  JOIN_CLASS_FAILED,
  JOIN_CLASS_REQ,
  JOIN_CLASS_SUCCESS,
} from "../Constant/AttendanceConstatnt";
import api from "../Core/api";

export const AttendanceRecordsList = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ATTENDANCE_REQ });
    const { data } = await api.get("/student/attendance");

    dispatch({ type: GET_ATTENDANCE_SUCCESS, payload: data?.Result });
  } catch (ex) {
    dispatch({
      type: GET_ATTENDANCE_FAILED,
      payload:
        ex.response && ex.response.data.Result
          ? ex.response.data.Result
          : ex.message,
    });
  }
};

export const AttendanceMarked = (attendanceData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ATTENDANCE_REQ });
    const { data } = await api.post("/student/attendance", attendanceData);

    dispatch({ type: CREATE_ATTENDANCE_SUCCESS, payload: data?.Result });
  } catch (ex) {
    dispatch({
      type: CREATE_ATTENDANCE_FAILED,
      payload:
        ex.response && ex.response.data.Result
          ? ex.response.data.Result
          : ex.message,
    });
  }
};

export const JoinClass = (ClassData, Class_Id) => async (dispatch) => {
  try {
    dispatch({ type: JOIN_CLASS_REQ });
    const { data } = await api.post(
      `/student/class/StartClass/${Class_Id}`,
      ClassData
    );
    dispatch({ type: JOIN_CLASS_SUCCESS, payload: data?.Result });
  } catch (ex) {
    dispatch({
      type: JOIN_CLASS_FAILED,
      payload:
        ex.response && ex.response.data.Result
          ? ex.response.data.Result
          : ex.message,
    });
  }
};
